import { useEffect, type ReactNode } from 'react'

import { Corners } from '@/shared/ui/Blueprint'

interface Props {
  title: string
  onClose: () => void
  actions: ReactNode
  children: ReactNode
}

/** Modal do DS (`.dialog-backdrop` + `.dialog.blueprint`). Fecha no Escape e no clique fora. */
export function Dialog({ title, onClose, actions, children }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div className="dialog-backdrop" onClick={onClose}>
      <div
        className="dialog blueprint"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
        style={{ background: 'var(--color-bg)' }}
      >
        <Corners />
        <div className="dialog-title">{title}</div>
        <div className="dialog-body">{children}</div>
        <div className="dialog-actions">{actions}</div>
      </div>
    </div>
  )
}
